<template>
    <div>
        <Layanan
            v-if="islayanan"
            v-bind:setidoutletsetservice="setidoutlet"
            ref="listlayanan"
            v-on:isdetailsetservice="isdetailsetservice"
            v-on:gocreateservice="showcreateservice"
            v-on:goeditlayanan="showeditservice"
        />
        <TambahLayananV2
            v-if="iscreate"
            v-bind:setidoutletsetservice="setidoutlet"
            v-on:gotolistlayanan="showlistservice"
        />
        <TambahLayananV2
            v-if="isedit"
            v-bind:setidoutletsetservice="setidoutlet"
            v-on:gotolistlayanan="showlistservice"
            v-bind:idlayanan="datalistlayanan.idlayanan"
        />
    </div>
</template>

<script>
import Layanan from "../../Layanan/Layanan";
import TambahLayananV2 from "../../Layanan/TambahLayananV2";
import EditLayanan from "../../Layanan/EditLayanan.vue";
export default {
    name: "PengaturanLayanan",
    components: { Layanan, TambahLayananV2, EditLayanan },
    props: ["setidoutlet"],
    data() {
        return {
            islayanan: false,
            iscreate: false,
            isedit: false,
            idoutlet: this.setidoutlet,
            parentidlayanan: "",
            layanansetservice: [],
            requestHeaders: {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("token"),
                },
            },

            datalistlayanan: {
                idlayanan: "",
            },
        };
    },
    mounted() {
        if (this.$route.params.idLayanan) {
            this.showeditservice(this.$route.params.idLayanan, false)
            return
        }
        this.showlistlayanan();


    },
    methods: {
        showlistlayanan() {
            this.islayanan = true;
            this.iscreate = false;
            this.isedit = false;
        },
        showlistservice() {
            this.islayanan = true;
            this.iscreate = false;
            this.isedit = false;
            $("#listlayanan").show();
            this.getlistlayanan();

        },
        showcreateservice() {
            this.islayanan = true;
            this.iscreate = true;
            this.isedit = false;
            $("#listlayanan").hide();
        },
        showeditservice(idlayanan, islayanan = true) {
            this.islayanan = islayanan;
            this.iscreate = false;
            this.isedit = true;
            $("#listlayanan").hide();
            this.datalistlayanan.idlayanan = idlayanan;
        },
        getlistlayanan() {
            setTimeout(() => {
                this.$refs.listlayanan.cekOnboardingLayanan();
            }, 1000);
            this.$refs.listlayanan.listlayanan(true);
            this.backButtonPressed(this.$refs.listlayanan.back);
        },
        isdetailsetservice() {
            this.$emit("isdetail");
        },
    },
};
</script>

<style scoped></style>
